var render = function render(){var _vm=this,_c=_vm._self._c;return _c('rkm-modal',{ref:"RkmModal",staticClass:"rkm-modal",attrs:{"buttons":['cancel', 'save'],"extra-large":"","title":"Procedimento"},on:{"save":_vm.handleSave}},[_c('Form',{ref:"Form",staticStyle:{"margin-top":"-1rem","margin-bottom":"-1rem"},attrs:{"data":_vm.data,"model":_vm.model},on:{"saved":_vm.saved}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }